export default __webpack_public_path__ + "static/media/Search.d6b62a0d.svg";